import React, { useMemo, useRef, useState,useEffect } from "react";
import { useTable } from "react-table";
import { Avatar, Box, Tooltip, ButtonGroup, TextField } from "@mui/material";
import MDButton from "components/MDButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SchoolIcon from "@mui/icons-material/School";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import { apiGet } from "../../../utils/api";
import UserModal from "./usuarioModal";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import ActualizarGruposEstado from "./actualizarGruposEstado";
import FactCheckIcon from "@mui/icons-material/FactCheck";

export default function EstudiantesTable({
  estudiantes,
  handleOpen,
  handleDeleteEstudiante,
  handleOpenCapacitacion,
  handleOpenCarrera,
  handleOpenKardex,
  handleOpenPagos,
  onActualizado
}) {
  const topScrollRef = useRef(null);
  const tableContainerRef = useRef(null); 
  const [estudiantesData, setEstudiantesData] = useState(estudiantes ?? []);
  const [openModal, setOpenModal] = useState(false);
  const [estudianteSeleccionado, setEstudianteSeleccionado] = useState(null);
  const [openActualizarGrupos, setOpenActualizarGrupos] = useState(false);
  const [usuarioIdActualizarGrupos, setUsuarioIdActualizarGrupos] = useState(null);
  const API_BASE = process.env.REACT_APP_API_URL;
  const BASE_URL = API_BASE.replace("/api/v2", "");

  const [search, setSearch] = useState(""); // <--- estado del buscador

  const handleOpenActualizarGrupos = (usuarioId) => {
    setUsuarioIdActualizarGrupos(usuarioId);
    setOpenActualizarGrupos(true);
  };

  const handleCloseActualizarGrupos = () => {
    setOpenActualizarGrupos(false);
    setUsuarioIdActualizarGrupos(null);
  };

  const handleOpenModal = (estudiante) => {
    setEstudianteSeleccionado(estudiante.usuario_id);
    setOpenModal(true);
  };

  // Cerrar modal
  const handleCloseModal = () => {
    setOpenModal(false);
    setEstudianteSeleccionado(null);
  };
  useEffect(() => {
    setEstudiantesData(estudiantes ?? []);
  }, [estudiantes]);

  const buscarEstudiante = async () => {
    if (!search.trim()){
      setEstudiantesData(estudiantes ?? []);
    return;}

    try {
      const res = await apiGet(`${process.env.REACT_APP_API_URL}/estudiante/${search}`);
      setEstudiantesData(Array.isArray(res) ? res : []);
    } catch (error) {
      console.error("Error al buscar estudiante", error);
    }
  };
  const columns = useMemo(() => [
  { Header: "Codigo", accessor: "codigo", width: 100 },
  {
      Header: "Foto de perfil",
      accessor: "foto_perfil",
      Cell: ({ row }) => {
        const foto = row.original.foto_perfil;
        const url = foto
          ? `${BASE_URL}/storage/${foto.replace(/\\/g, "/")}`
          : `${BASE_URL}/storage/perfiles/avatarpredeterminado.png`;
        return <Avatar src={url} alt="Foto" sx={{ width: 50, height: 50 }} />;
      },
      width: 80
    },
  { Header: "Nombre", accessor: "name", width: 150 },
  { Header: "Apellido Paterno", accessor: "apellido_paterno", width: 120 },
  { Header: "Apellido Materno", accessor: "apellido_materno", width: 120 },

  // Aquí ponemos los botones de acciones **antes de info y programas**
  {
    Header: "Acciones",
    id: "acciones_col",
    Cell: ({ row }) => {
      const estudiante = row.original;
      return (
        <Box sx={{ display: "flex", gap: 1 }}>
          <Tooltip title="Editar">
            <MDButton color="info" size="small" onClick={() => handleOpen(estudiante)}>
              <EditIcon />
            </MDButton>
          </Tooltip>
          <Tooltip title="Eliminar">
            <MDButton color="error" size="small" onClick={() => handleDeleteEstudiante(estudiante.usuario_id)}>
              <DeleteIcon />
            </MDButton>
          </Tooltip>
          <Tooltip title="Inscribir / Reinscribir estudiante">
            <MDButton color="primary" size="small" onClick={() => handleOpenCarrera(estudiante.usuario_id)}>
              <SchoolIcon />
            </MDButton>
          </Tooltip>
          <Tooltip title="Actualizar grupo y estado">
            <MDButton
              color="warning"
              size="small"
              onClick={() =>
                handleOpenActualizarGrupos(estudiante.usuario_id)
              }
            >
              <FactCheckIcon />
            </MDButton>
          </Tooltip>
          <Tooltip title="Dar acceso al sistema">
            <MDButton
              color="success"
              size="small"
              onClick={() => handleOpenModal(estudiante)}
            >
              <VpnKeyIcon />
            </MDButton>
          </Tooltip>
        </Box>
      );
    },
    width: 220
  },

  { Header: "CI", accessor: "ci", width: 100 },
  { Header: "Expedido", accessor: "expedido", width: 80 },
  { Header: "Celular", accessor: "celular", width: 120 },
  { Header: "Email", accessor: "email", width: 180 },
  {
      Header: "Carrera / Capacitación",
      id: "programas_col",
      Cell: ({ row }) => {
        const programas = [row.original.carreras, row.original.capacitaciones].filter(Boolean);
        return programas.length
            ? programas.map((p, i) => <div key={`${row.original.id}-p-${i}`}>• {p}</div>)
            : "—";
      },
      width: 200
    },
  { Header: "Instituto", accessor: "institucion", width: 150 },
  {
    Header: "Fecha Inscripción",
    accessor: (row) =>
      row.fecha_inscripcion_carrera || row.fecha_inscripcion_capacitacion,
    id: "fecha_inscripcion",
    width: 130,
  },
  {
    Header: "Estado",
    id: "estado_inscripciones",
    Cell: ({ row }) => {
      const detalles = row.original.detalle_inscripciones || [];

      // Cuando viene de listadoEstudiantes()
      if (detalles.length) {
        const visibles = detalles.slice(0, 3);
        const restantes = detalles.length - visibles.length;

        return (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              minWidth: 220,
              maxWidth: 280,
            }}
          >
            {visibles.map((item, index) => (
              <Box
                key={`${item.id}-${index}`}
                sx={{
                  borderBottom:
                    index < visibles.length - 1
                      ? "1px solid #ddd"
                      : "none",
                  pb: index < visibles.length - 1 ? 1 : 0,
                }}
              >
                <Box
                  sx={{
                    fontWeight: "bold",
                    fontSize: "0.8rem",
                  }}
                >
                  {item.programa}
                </Box>

                <Box
                  sx={{
                    fontSize: "0.75rem",
                    color: "#666",
                  }}
                >
                  {item.tipo_inscripcion} → {item.estado}
                </Box>
              </Box>
            ))}

            {restantes > 0 && (
              <Box
                sx={{
                  fontSize: "0.75rem",
                  fontWeight: "bold",
                  color: "#1976d2",
                }}
              >
                + {restantes} más...
              </Box>
            )}
          </Box>
        );
      }

      // Cuando viene de buscarEstudiante()
      return row.original.estado_inscripcion || "—";
    },
    width: 280,
  },
  {
    Header: "Información",
    id: "info_col",
    Cell: ({ row }) => (
      <ButtonGroup variant="contained" size="small">
        <MDButton color="secondary" onClick={() => handleOpenKardex(row.original.usuario_id)}>Kardex</MDButton>
        <MDButton color="info" onClick={() => handleOpenPagos(row.original.usuario_id)}>Pagos</MDButton>
      </ButtonGroup>
    ),
    width: 180
  },
], [handleOpen, handleDeleteEstudiante, handleOpenCapacitacion, handleOpenCarrera, handleOpenKardex, handleOpenPagos]);

  const handleScroll = (source, target) => {
    if (target.current) {
      target.current.scrollLeft = source.current.scrollLeft;
    }
  };

const data = useMemo(() => estudiantesData, [estudiantesData]);
const tableInstance = useTable({ columns, data });
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = tableInstance;

  return (
    <Box sx={{ width: "100%", mt: 2, p: 2 }}>
  {/* Buscador */}
  <Box
    sx={{
      mb: 2,
      maxWidth: 500,
      display: "flex",
      alignItems: "center",
      gap: 1.5,
    }}
  >
    <TextField
      label="Buscar por nombre"
      variant="outlined"
      size="small"
      value={search}
      onChange={(e) => {
        const val = e.target.value;
        setSearch(e.target.value)
         if (!val.trim()) setEstudiantesData(estudiantes ?? []);
      }}
      fullWidth
      sx={{
        "& .MuiInputLabel-root": { fontSize: "0.85rem" },
        "& .MuiInputBase-input": { fontSize: "0.9rem", py: "6px", px: "10px" },
        flex: 1,
      }}
    />

    <MDButton
      variant="contained"
      color="info"
      onClick={buscarEstudiante}
      sx={{
        height: 38,
        whiteSpace: "nowrap",
      }}
      
    >
      Buscar
    </MDButton>
  </Box>



  <Box
    ref={topScrollRef}
    onScroll={() => handleScroll(topScrollRef, tableContainerRef)}
    sx={{ overflowX: "auto", width: "100%", mb: 1 }}
  >
    <div style={{ width: 3000, height: "1px" }} />
  </Box>

  <Box
    ref={tableContainerRef}
    onScroll={() => handleScroll(tableContainerRef, topScrollRef)}
    sx={{
      width: "100%",
      overflowX: "auto",
      borderRadius: 2,
      boxShadow: 1,

      // 👇 ocultar scroll pero permitir desplazamiento
      scrollbarWidth: "none",        // Firefox
      "&::-webkit-scrollbar": {
        display: "none",             // Chrome, Safari
      },
    }}
      >
    <table
      {...getTableProps()}
      style={{
        width: "100%",
        borderCollapse: "separate",
        borderSpacing: "0 5px",
        minWidth: 3000,
      }}
    >
      <thead>
        {headerGroups.map(headerGroup => (
          <tr
            {...headerGroup.getHeaderGroupProps()}
            key={headerGroup.id}
            style={{
              background: "#1976d2",
              color: "#fff",
              textTransform: "uppercase",
              fontSize: "0.85rem", 
            }}
          >
            {headerGroup.headers.map(column => (
              <th
                {...column.getHeaderProps()}
                key={column.id}
                style={{
                  borderBottom: "2px solid #1565c0",
                  padding: "8px 12px",
                  textAlign: "center",
                  minWidth: column.width,
                  whiteSpace: "nowrap",
                }}
              >
                {column.render("Header")}
              </th>
            ))}
          </tr>
        ))}
      </thead>

      <tbody {...getTableBodyProps()}>
        {rows.map((row) => {
          prepareRow(row);
          return (
            <tr
              {...row.getRowProps({ key: row.original.id || row.id })}
              style={{
                background: row.index % 2 === 0 ? "#f5f5f5" : "#fff",
                boxShadow: "0px 1px 2px rgba(0,0,0,0.05)",
                borderRadius: 4,
              }}
            >
              {row.cells.map((cell, cellIndex) => (
                <td
                  {...cell.getCellProps({ key: cell.column.id || cellIndex })}
                  style={{
                    padding: "8px 10px",
                    textAlign: "center",
                    fontSize: "0.85rem",
                    verticalAlign: "middle",
                  }}
                >
                  {cell.render("Cell")}
                </td>
              ))}
            </tr>
          );
        })}
      </tbody>
    </table>
    <UserModal
      userId={estudianteSeleccionado}
      open={openModal}
      onClose={handleCloseModal}
      onUpdate={(updatedUser) => {
        console.log("Usuario actualizado:", updatedUser);
        // Opcional: actualizar la lista de estudiantes
        setEstudiantesData((prev) =>
          prev.map((e) => (e.id === updatedUser.id ? updatedUser : e))
        );
      }}
    />
    <ActualizarGruposEstado
      open={openActualizarGrupos}
      onClose={handleCloseActualizarGrupos}
      usuarioId={usuarioIdActualizarGrupos}
      onActualizado={onActualizado}
    />
  </Box>
</Box>

  );
}
